module.exports = __webpack_public_path__ + "img/agingcare_accset_202411.ff85c4a7.jpg";